import React from "react";
import { Box, Typography } from "@mui/material";
import { Check, X } from "lucide-react";
import { colors } from "../../colors/colors";
import { getPasswordRequirementChecks } from "./passwordValidation";
import {
  passwordRequirementsTitleSx,
  passwordRequirementsListSx,
  passwordRequirementsItemSx,
  passwordRequirementsItemRowSx,
  passwordRequirementsIconSx,
} from "./styles";

interface PasswordRequirementsProps {
  password: string;
  showValidation?: boolean;
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password,
  showValidation = false,
}) => {
  const shouldShowStatus = showValidation || password.length > 0;
  const requirements = getPasswordRequirementChecks(password);

  return (
    <Box>
      <Typography variant="body2" sx={passwordRequirementsTitleSx}>
        Password Requirements:
      </Typography>
      <Box component="ul" sx={passwordRequirementsListSx}>
        {requirements.map(({ id, label, met }) => {
          const isMet = shouldShowStatus && met;
          const isUnmet = shouldShowStatus && !met;

          return (
            <Box
              key={id}
              component="li"
              sx={passwordRequirementsItemRowSx}
            >
              {shouldShowStatus && (
                <Box
                  component="span"
                  sx={passwordRequirementsIconSx(isMet, isUnmet)}
                  aria-hidden
                >
                  {isMet ? <Check size={14} strokeWidth={3} /> : <X size={14} strokeWidth={3} />}
                </Box>
              )}
              <Typography
                component="span"
                variant="body2"
                sx={{
                  ...passwordRequirementsItemSx,
                  ...(isMet && {
                    color: "#16A34A",
                    fontWeight: 500,
                  }),
                  ...(isUnmet && {
                    color: colors.error,
                    fontWeight: 500,
                  }),
                }}
              >
                {label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
